import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import Image from '@/components/Image';
import { Typography } from '@/components/shared/Typography';
import { TeamPersonDto } from '@/components/WebsiteProdPage/TeamSection/types';
import css from './style.module.scss';
interface Props {
  person: TeamPersonDto;
  className?: string;
}
const PersonItem: FC<Props> = t0 => {
  const $ = _c(13);
  const {
    person,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx(css.personItem, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = person.photo.alternativeText || person.position || "";
  let t3;
  if ($[2] !== person.photo.height || $[3] !== person.photo.url || $[4] !== person.photo.width || $[5] !== t2) {
    t3 = <Image className={css.personPhoto} src={person.photo.url} width={person.photo.width} height={person.photo.height} quality={100} alt={t2} />;
    $[2] = person.photo.height;
    $[3] = person.photo.url;
    $[4] = person.photo.width;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== person.position) {
    t4 = <Typography className={css.personLabel} variant="h6" tag="figcaption">{person.position}</Typography>;
    $[7] = person.position;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4) {
    t5 = <figure className={t1}>{t3}{t4}</figure>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default PersonItem;